<template>
    <div>
        <div class="modal fade bd-example-modal-lg termsModal" ref="rejectModal" id="accept-modal" tabindex="-1"
             role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="TermsModalLabel">Explain why invoice is rejected</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <textarea class="form-control" height="400px" placeholder="Comment for rejecting invoice"
                                  v-model="comment"></textarea>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-dark" data-dismiss="modal">Go back
                        </button>
                        <button type="button" @click="confirmReject" class="btn btn-danger" data-dismiss="modal">Reject
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-header">
            Accept or Reject the invoice
        </div>
        <div class="card-body">
            <p class="invoice-state-description">
                Review the invoice details and mark the invoice as Accepted or Rejected.
            </p>
            <div class="row">
                <div class="col-6">
                    <button type="submit" class="btn btn-primary btn-block" @click.prevent="accept">Accept invoice
                    </button>
                </div>
                <div class="col-6">
                    <button type="submit" class="btn btn-danger btn-block" @click.prevent="reject">Reject invoice</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import DefaultState from './DefaultState';

  export default {
    name: 'Pending',
    extends: DefaultState,
    data() {
      return {
        comment: undefined,
      };
    },
    methods: {
      accept() {
        this.action({transition: this.getTransition('Accepted')});
      },
      reject() {
        $(this.$refs.rejectModal).modal('show');
      },
      confirmReject() {
        if (!this.comment) {
          this.$toasted.error('No comment set');
          return;
        }
        this.action({transition: this.getTransition('Rejected'), comment: this.comment});
      },
    },
  };
</script>

<style scoped>

</style>
